import React, { Component, Fragment } from 'react';
import { DetailsList, SelectionMode, Selection } from 'office-ui-fabric-react/lib/DetailsList';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { MessageBars } from '../Outils/MessageBars';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import { ComboBoxProduit } from '../ComboBox/ComboBoxProduit';
import { ComboBoxStatutMandat } from '../ComboBox/ComboBoxStatutMandat';
import { ComboBoxTypeMandat } from '../ComboBox/ComboBoxTypeMandat';
import { DetailsListCompte } from './DetailsListCompte';
import { FicheCompte } from '../Fiche/FicheCompte';
import { FicheSociete } from '../Fiche/FicheSociete';
import FicheMandat from '../Fiche/FicheMandat';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';
import { DataMandat } from '../../data/DataMandat';
import PerimetreContext from '../../contexts/PerimetreContext';

export class DetailsListMandat extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListMandatWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListMandatWithPerimetre extends Component {

    static defaultProps = {
        perimetre: {}
    };

    _creationContent = () => {
        const { items } = this.state;

        return <DetailsList
            setKey="items"
            items={items}
            selectionMode={SelectionMode.none}
            columns={this.columns}
            onColumnHeaderClick={this._onColumnHeaderClick}
            onRenderDetailsHeader={this._onRenderDetailsHeader}
        />;
    };

    constructor(props) {
        super(props);

        //*****************************************************************
        //gestion des paramètres
        //*****************************************************************
        this._letParametreMode = '';
        this._letFiltreTypeMandat = '';

        if (this.props.match !== undefined) {
            if (this.props.match.params.Mode !== undefined) {
                if (this.props.match.params.Mode === "Type") {
                    this._letParametreMode = 'Type';
                    this._letFiltreTypeMandat = this.props.match.params.Valeur;
                }
            }
        }
        //*****************************************************************

        this._societeSelectionnee = {};
        this.state = {
            items: [],
            idMandat: 0,
            idTypeMandat: null,

            parametreMode: this._letParametreMode,
            filtreTypeMandat: this._letFiltreTypeMandat,
            filtreDateFinExpire: false,

            enCoursDeTraitement: false,

            onAffichePanelMandat: false,
            onAffichePanelFiltres: false,
            onAfficheDialogSuppressionMandat: false,
            onAfficheDialogSuppressionMandatToutProduit: false,
            peutAccederAuMandat: false,
            peutCreerMandat: false,
            peutSupprimerMandat: false,
            peutModifierMandat: false,
            peutAccederAuProfil: false,
            peutCreerProfil: false,
            peutSupprimerProfil: false,
            peutModifierProfil: false,

            onPeutChargerLeComposantFicheCompte: false,

            pageIndex: 1,
            facteurNbreEnregistrement: 50,
            tri: "",

            hideMessageBarWarning: true,
            hideMessageBarError: true,
            hideMessageBarFiltres: true,
            warningMessage: '',
            errorMessage: '',
            messageMessageBarFiltres: '',

            recherche: '',

            filtreIdStatutMandat: 0,
            filtreIdProduit: 0,
            filtreIdTypeMandat: 0
        };

        this.columns = this._getColumns();
    }

    _getItems = () => {
        let tableauBoutons = [
            {
                key: 'search',
                onRender: () => <SearchBox
                    placeholder="Recherche rapide"
                    className="searchBox"
                    onSearch={value => this._onSearchBox(value)}
                    onClear={(e) => this._onSearchBox('')}
                //onBlur={(e) => this._onBlurSearchBox(e.target.value)}
                />
            },
        ];

        if (this.state.peutCreerMandat) {

            if (this.state.filtreTypeMandat == 'Societe') {
                const boutonNouveauSouhait = {
                    key: 'nouveauMandatCommercialisateur',
                    name: 'Nouveau Mandat Commercialisateur',
                    iconProps: { iconName: 'Add' },
                    onClick: (this._afficherPanelMandat(0, 2))
                };
                tableauBoutons.push(boutonNouveauSouhait);
            }

            else if (this.state.filtreTypeMandat == 'Eiffage') {
                const boutonNouveauSouhaitCommercialisateur = {
                    key: 'nouveauMandatCommercialisateur',
                    name: 'Nouveau Mandat Commercialisateur',
                    iconProps: { iconName: 'Add' },
                    onClick: (this._afficherPanelMandat(0, 2))
                };
                tableauBoutons.push(boutonNouveauSouhaitCommercialisateur);

                const boutonNouveauSouhait = {
                    key: 'nouveauMandatAutre',
                    name: 'Nouveau Mandat Autre',
                    iconProps: { iconName: 'Add' },
                    onClick: (this._afficherPanelMandat(0, 0))
                };
                tableauBoutons.push(boutonNouveauSouhait);
            }

            else if (this.state.filtreTypeMandat == 'WS') {
                const boutonNouveauSouhait = {
                    key: 'nouveauMandatWebServices',
                    name: 'Nouveau Mandat Web Services',
                    iconProps: { iconName: 'Add' },
                    onClick: (this._afficherPanelMandat(0, 5))
                };
                tableauBoutons.push(boutonNouveauSouhait);
            }

        }

        if (this.state.peutCreerProfil) {
            const boutonNouveauCompte = {
                key: 'nouveauCompte',
                name: 'Nouveau compte',
                iconProps: { iconName: 'AddFriend' },
                onClick: (this._afficherPanelCompte)
            };
            tableauBoutons.push(boutonNouveauCompte);
        }

        if (this.state.filtreTypeMandat !== "Eiffage" && this.state.peutCreerProfil) {
            const boutonNouvelleSociete = {
                key: 'nouvelleSociete',
                name: 'Nouvelle société',
                iconProps: { iconName: 'AddHome' },
                onClick: (this._afficherPanelSociete(null))
            };
            tableauBoutons.push(boutonNouvelleSociete);
        }

        return tableauBoutons;
    };

    _getFarItems = () => {
        return [
            {
                key: 'nombreEnregistrement',
                name: (this.state.items != null ? this.state.items.length : 0)
            },
            {
                key: 'filtres',
                name: 'Filtres',
                iconProps: { iconName: 'Filter' },
                iconOnly: true,
                onClick: this._afficherPanelFiltres
            }
        ];
    };

    _onSuppressionMandat = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Suppression du mandat en cours'
        });

        let onSuppressionMandat = DataMandat._onSuppressionMandat(this.state.idMandat);

        onSuppressionMandat
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                let stateTemp = {
                    onAfficheDialogSuppressionMandat: false,
                    onAfficheDialogSuppressionMandatToutProduit: false,
                    idMandat: 0,
                    idTypeMandat: null
                };
                if (retourVerif === null) {
                    stateTemp.pageIndex = 1;
                    this.setState(stateTemp, this._chargementDonnees);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    };

    _chargementDonnees = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des mandats en cours'
        });

        let chargementDesMandats = DataMandat._chargementDesMandats(this.state.recherche, this.state.tri, this._letFiltreTypeMandat, this.state.filtreIdStatutMandat, this.state.filtreIdProduit, this.state.filtreIdTypeMandat, this.state.facteurNbreEnregistrement, this.state.pageIndex, this.state.filtreDateFinExpire);

        chargementDesMandats.then(responseFetch => {
            let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

            if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                let new_Items = [];
                const retourData = responseFetch.reponseAPIobjet;
                //const listeItem = retourData[0];
                //YD : 17/06/2020 : Ajout test sur listeItem != null
                let listeItem = (retourData[0] !== null ? retourData[0] : []);

                const peutCreerMandat = retourData[1];
                const peutSupprimerMandat = retourData[2];
                const peutModifierMandat = retourData[3];

                const peutCreerProfil = retourData[4];
                const peutSupprimerProfil = retourData[5];
                const peutModifierProfil = retourData[6];

                const peutAccederAuMandat = retourData[7];
                const peutAccederAuProfil = retourData[8];

                if (this.state.pageIndex === 1) {
                    new_Items = listeItem;
                }
                else {
                    new_Items = this.state.items;
                    new_Items = new_Items.concat(listeItem);
                }

                this.setState({
                    items: new_Items,

                    peutCreerMandat,
                    peutSupprimerMandat,
                    peutModifierMandat,

                    peutCreerProfil,
                    peutSupprimerProfil,
                    peutModifierProfil,

                    peutAccederAuMandat,
                    peutAccederAuProfil,

                    enCoursDeTraitement: false,
                    hideMessageBarWarning: retourVerif.hideMessageBarWarning,
                    warningMessage: retourVerif.warningMessage,
                    hideMessageBarError: retourVerif.hideMessageBarError,
                    errorMessage: retourVerif.errorMessage,
                    hideMessageBarFiltres: (responseFetch.messageInfo === "" || responseFetch.messageInfo === null),
                    messageMessageBarFiltres: responseFetch.messageInfo
                });
            }
            else {
                let stateTemp = {};
                stateTemp.items = [];

                stateTemp.peutCreerMandat = false;
                stateTemp.peutSupprimerMandat = false;
                stateTemp.peutModifierMandat = false;

                stateTemp.peutCreerProfil = false;
                stateTemp.peutSupprimerProfil = false;
                stateTemp.peutModifierProfil = false;

                stateTemp.peutAccederAuMandat = false;
                stateTemp.peutAccederAuProfil = false;

                Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
            }
        });
    };

    //_setEstAdminNational = () => {
    //    let getEstAdminNational = DataCompte._getEstAdminNational(null);
    //    getEstAdminNational.then(responseFetch => {
    //        let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

    //        if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
    //            const retourData = responseFetch.reponseAPIobjet;
    //            this.setState({ estAdminNational: retourData.estAdminNational });
    //        }
    //        else {
    //            let stateTemp = { estAdminNational: false };
    //            Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
    //        }
    //    });
    //};

    _getColumns = () => {
        let columns = [];

        columns.push(this._letFiltreTypeMandat !== "Eiffage" ?
            {
                key: 'nomSociete',
                name: 'Société',
                ariaLabel: 'Société',
                fieldName: 'nomSociete',
                minWidth: 200,
                maxWidth: 300,
                isResizable: true,
                onRender: (item) => {
                    return <Fragment>
                        <span title={item.nomSociete}>{item.nomSociete}</span>
                        {this.state.peutModifierProfil &&
                            <IconButton
                                ariaLabel="Modifier la société"
                                iconProps={
                                    {
                                        iconName: "Edit",
                                        styles: {
                                            root: {
                                                alignSelf: "baseline",
                                                fontSize: 12.5
                                            }
                                        }
                                    }
                                }
                                onClick={this._afficherPanelSociete(item)}
                                size="small"
                                title="Modifier la société"
                            />
                        }
                    </Fragment>;
                }
            } :
            {
                key: 'nomMandataire',
                name: 'Compte',
                ariaLabel: 'Compte',
                fieldName: 'nomMandataire',
                minWidth: 200,
                maxWidth: 300,
                isResizable: true,
                headerClassName: 'ms-hiddenMdDown',
                className: 'ms-hiddenMdDown',
                onRender: (item) => {
                    return <span title={item.nomMandataire}>{item.nomMandataire}</span>;
                }
            }
        );
        columns.push({
            key: 'Region',
            name: 'Région',
            ariaLabel: 'Région',
            fieldName: 'Region',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            onRender: (item) => {
                return <span title={item.region}>{item.region}</span>;
            }
        });
        columns.push({
            key: 'Agence',
            name: 'Agence',
            ariaLabel: 'Agence',
            fieldName: 'Agence',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return <span title={item.agence}>{item.agence}</span>;
            }
        });
        columns.push({
            key: 'nomCommercial',
            name: 'Opération',
            ariaLabel: 'Opération',
            fieldName: 'nomCommercial',
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            onRender: (item) => {
                return <span title={item.nomCommercial}>{item.nomCommercial}</span>;
            }
        });
        columns.push({
            key: 'nbreLotCommercial',
            name: 'X lots',
            ariaLabel: 'Nombre de lots',
            fieldName: 'nbreLotCommercial',
            minWidth: 40,
            maxWidth: 40,
            isResizable: true,
            headerClassName: 'ms-hiddenXlDown',
            className: 'ms-hiddenXlDown',
            onRender: (item) => {
                return <span title={item.nbreLotCommercial}>{item.nbreLotCommercial}</span>;
            }
        });
        //columns.push({
        //    key: 'mandatToutProduit',
        //    name: 'Tous Produits',
        //    ariaLabel: 'mandatToutProduit',
        //    fieldName: 'mandatToutProduit',
        //    minWidth: 80,
        //    maxWidth: 80,
        //    isResizable: true,
        //    headerClassName: 'ms-hiddenXlDown',
        //    className: 'ms-hiddenXlDown',
        //    onRender: (item) => {
        //        return <span title={item.mandatToutProduit}>{item.mandatToutProduit}</span>;
        //    }
        //});
        columns.push({
            key: 'produit',
            name: 'Type de produit',
            ariaLabel: 'Type de produit',
            fieldName: 'produit',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenXlDown',
            className: 'ms-hiddenXlDown',
            onRender: (item) => {
                return <span title={item.produit}>{item.produit}</span>;
            }
        });
        columns.push({
            key: 'honoraireCommercialisation',
            name: 'Taux d\'honoraires',
            ariaLabel: 'Taux',
            fieldName: 'honoraireCommercialisation',
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
            headerClassName: 'ms-hiddenXlDown',
            className: 'ms-hiddenXlDown',
            onRender: (item) => {
                return <span title={item.honoraireCommercialisation}>{item.honoraireCommercialisation}</span>;
            }
        });
        columns.push({
            key: 'dateDebut',
            name: 'Date de début',
            ariaLabel: 'Date de début',
            fieldName: 'dateDebut',
            minWidth: 85,
            maxWidth: 85,
            isResizable: true,
            onRender: (item) => {
                let dateDebut = Scriba.date().stringDateFormatCourt(item.dateDebut);
                return <span title={dateDebut}>{dateDebut}</span>;
            }
        });
        columns.push({
            key: 'dateFin',
            name: 'Date de fin',
            ariaLabel: 'Date de fin',
            fieldName: 'dateFin',
            minWidth: 85,
            maxWidth: 85,
            isResizable: true,
            headerClassName: 'ms-hiddenXlDown',
            className: 'ms-hiddenXlDown',
            onRender: (item) => {
                let dateFin = Scriba.date().stringDateFormatCourt(item.dateFin);
                return <span title={dateFin}>{dateFin}</span>;
            }
        });
        columns.push({
            key: 'exclusivite',
            name: 'Exclu.',
            ariaLabel: 'Exclusivité',
            fieldName: 'exclusivite',
            minWidth: 40,
            maxWidth: 40,
            isResizable: true,
            headerClassName: 'ms-hiddenXlDown',
            className: 'ms-hiddenXlDown',
            onRender: (item) => {
                return <span title={item.exclusivite}>{item.exclusivite}</span>;
            }
        });
        columns.push({
            key: 'statutMandat',
            name: 'Statut',
            ariaLabel: 'Statut',
            fieldName: 'statutMandat',
            minWidth: 80,
            maxWidth: 80,
            isResizable: true,
            headerClassName: 'ms-hiddenXlDown',
            className: 'ms-hiddenXlDown',
            onRender: (item) => {
                return <span title={item.statutMandat}>{item.statutMandat}</span>;
            }
        });
        columns.push({
            key: 'typeMandat',
            name: 'Type de mandat',
            ariaLabel: 'Type de mandat',
            fieldName: 'typeMandat',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenXlDown',
            className: 'ms-hiddenXlDown',
            onRender: (item) => {
                return <span title={item.typeMandat}>{item.typeMandat}</span>;
            }
        });
        columns.push({
            key: 'show',
            iconName: null,
            isIconOnly: true,
            minWidth: 20,
            maxWidth: 20,
            name: 'Consulter',
            onRender: (item) => {
                return (this.state.peutAccederAuProfil ?
                    (this._letFiltreTypeMandat !== "Eiffage" ?
                        <IconButton
                            ariaLabel="Consulter les comptes associés"
                            iconProps={{ iconName: 'ContactList' }}
                            onClick={() => this._onAffichagePanelComptes(item)}
                            title="Consulter les comptes associés"
                        /> :
                        <IconButton
                            iconProps={{ iconName: 'EditContact' }}
                            title="Modifier le compte"
                            ariaLabel="Edition"
                            onClick={() => this._onAffichagePanelCompte(item.loginCompte)}
                        />)
                    : null);
            }
        });
        columns.push({
            key: 'EditionMandat',
            name: '',
            ariaLabel: 'Valider/Editer le mandat',
            fieldName: 'EditionMandat',
            minWidth: 20,
            maxWidth: 20,
            isIconOnly: true,
            onRender: (item) => {
                return (this.state.peutModifierMandat ? <IconButton
                    iconProps={{ iconName: "Edit" }}
                    title="Valider/Editer le mandat"
                    ariaLabel="Edition"
                    onClick={this._afficherPanelMandat(item.idMandat, item.idTypeMandat)}
                />
                    : null);
            }
        });
        columns.push({
            key: 'delete',
            name: 'Delete',
            ariaLabel: 'Supprimer le mandat',
            fieldName: 'delete',
            minWidth: 20,
            maxWidth: 20,
            iconName: '',
            isIconOnly: true,
            onRender: (item) => {
                return (item.mandat_Supprimer ? <IconButton
                    iconProps={{ iconName: 'Delete' }}
                    title="Supprimer le mandat"
                    ariaLabel="Suppression"
                    onClick={this._afficherDialogSuppressionMandat(item.idMandat, item.mandatToutProduit)}
                />
                    : null);
            }
        });

        return columns;
    };

    _afficherDialogSuppressionMandat = (idMandat, mandatToutProduit) => () => {
        if (!mandatToutProduit) {
            this.setState({
                onAfficheDialogSuppressionMandat: true,
                idMandat: idMandat,
            });
        }
        else {
            this.setState({
                onAfficheDialogSuppressionMandatToutProduit: true,
                idMandat: idMandat,
            });
        }
    };

    _afficherPanelCompte = () => {
        this.setState({ onAffichePanelCompte: true });
    };

    _afficherPanelComptes = (societe) => () => {
        this._societeSelectionnee = societe;
        this.setState({ onAffichePanelComptes: true });
    };

    _afficherPanelFiltres = () => {
        this.setState({
            onAffichePanelFiltres: true
        });
    };

    _afficherPanelMandat = (idMandat, idTypeMandat) => () => {
        this.setState({
            onAffichePanelMandat: true,
            idMandat: idMandat,
            idTypeMandat: idTypeMandat
        });
    };

    _afficherPanelSociete = (societe) => () => {
        if (societe)
            this._societeSelectionnee = societe;
        this.setState({ onAffichePanelSociete: true });
    };

    _masquerDialogSuppressionMandat = () => {
        this.setState({
            onAfficheDialogSuppressionMandat: false,
            onAfficheDialogSuppressionMandatToutProduit: false,
            idMandat: 0,
            idTypeMandat: null
        });
    };

    _masquerPanelCompte = () => {
        this.setState({ onAffichePanelCompte: false });
    };

    _masquerPanelCompteEtRechargerLesDonnees = () => {
        this.setState({ onAffichePanelCompte: false });
        this._chargementDonnees();
    };

    _masquerPanelComptes = () => {
        this._societeSelectionnee = {};
        this.setState({ onAffichePanelComptes: false });
    };

    _masquerPanelFiltres = () => {
        this.setState({ onAffichePanelFiltres: false });
    };

    _masquerPanelMandat = () => {
        this.setState({
            onAffichePanelMandat: false,
            idMandat: 0,
            idTypeMandat: null
        });
    };

    _masquerPanelMandatEtRechargerLesDonnees = () => {
        this.setState({
            onAffichePanelMandat: false,
            idMandat: 0,
            idTypeMandat: null
        }, this._chargementDonnees);
    };

    _onAffichagePanelComptes = (item) => {
        this._societeSelectionnee = item;
        this.setState({ onAffichePanelComptes: true });
    };

    _masquerPanelSociete = (rechargerLesDonnees) => () => {
        this._societeSelectionnee = {};
        this.setState({ onAffichePanelSociete: false });

        if (rechargerLesDonnees)
            this._chargementDonnees();
    };

    _onAffichagePanelCompte = (loginCompte) => {
        this._compteSelectionne = loginCompte;
        this.setState({ onAffichePanelCompte: true });
    }

    _onDismissPanelCompte = () => {
        this._compteSelectionne = undefined;
        this.setState({ onAffichePanelCompte: false });
    };

    _onCachePanelCompteEtRechargementDesDonnees = () => {
        this._onDismissPanelCompte();
        this._chargementDonnees();
    };

    _onSearchBox = (text) => {
        this.setState({
            recherche: text,
            pageIndex: 1
        }, this._chargementDonnees);
    };

    _onFiltreTableau = () => {
        this.setState(
            { pageIndex: 1 },
            this._chargementDonnees
        );
        this._masquerPanelFiltres();
    };

    _reinitFiltres = () => {
        this.setState({
            pageIndex: 1,
            filtreIdStatutMandat: 0,
            filtreIdProduit: 0,
            filtreIdTypeMandat: 0
        });
    };

    _onSelectDate = (value, champ) => {
        var valeurDate = Scriba.date().getChaineISOFromDate(value, true);
        this.setState({ [champ]: valeurDate });
    };

    _onColumnHeaderClick = (ev, column) => {
        const columns = this.columns;
        const newColumns = columns.slice();
        const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];

        newColumns.forEach((newCol) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = false;
            }
        });

        let tri = column.key + (column.isSortedDescending ? ' DESC' : ' ASC');

        this.setState(
            { tri, pageIndex: 1 },
            this._chargementDonnees
        );
    };

    _incrementeNbreEnregistrementEtChargementDonnees = () => {
        this.setState(
            prevState => ({ pageIndex: prevState.pageIndex + 1 }),
            this._chargementDonnees
        );
    };

    _modificationNbreEnregistrementParPageETrepositionnementDuScrollEnHautDeLaPage = (value) => {
        this.setState({ facteurNbreEnregistrement: value, pageIndex: 1 });
    };

    _onScroll = (e) => {
        if ((e.target.scrollHeight - e.target.clientHeight) === (Math.trunc(e.target.scrollTop))) {
            this._incrementeNbreEnregistrementEtChargementDonnees();
        }
    };

    _onRenderDetailsHeader = (props, defaultRender) => {
        return (
            <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
                {defaultRender({
                    ...props,
                    onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
                })}
            </Sticky>
        );
    };

    _onRenderFooterFiltresContent = () => {
        return (
            <div>
                <PrimaryButton onClick={this._onFiltreTableau} className="marginRight8px">Valider</PrimaryButton>
                <DefaultButton onClick={this._masquerPanelFiltres}>Fermer</DefaultButton>
            </div>
        );
    };

    componentDidMount = () => {
        this._chargementDonnees();
    };

    //componentDidUpdate = () => {
    //    //if (this.state.estAdminNational !== prevState.estAdminNational)
    //    //    this.setState({ columns: this._getColumns() });
    //    //*************************************************************
    //    //ne marche pas
    //    //if(this.props.onRecharge === true)
    //    //    this._chargementDonnees();
    //    //*************************************************************
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    //    }

    //    if (this._letFiltreTypeMandat !== this.state.filtreTypeMandat) {
    //        this.setState({
    //            parametreMode: this._letParametreMode,
    //            filtreTypeMandat: this._letFiltreTypeMandat,
    //        });
    //    }
    //};

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this.setState({ pageIndex: 1 }, this._chargementDonnees);

        if (this._letFiltreTypeMandat !== this.state.filtreTypeMandat) {
            this.setState({
                parametreMode: this._letParametreMode,
                filtreTypeMandat: this._letFiltreTypeMandat,
            });
        }
    };

    componentWillUnmount = () => {
        //document.removeEventListener('scroll', this._evenementScroll);
    };

    render = () => {

        const content = this._creationContent();

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                    farItems={this._getFarItems()}
                    ariaLabel={'Utiliser les flèches droite et gauche pour naviguer'}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane
                        scrollbarVisibility={ScrollbarVisibility.auto}
                        onScroll={this._onScroll}
                    >
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

            <Panel
                isOpen={this.state.onAffichePanelFiltres}
                type={PanelType.smallFixedFar}
                onDismiss={this._masquerPanelFiltres}
                headerText="Filtres"
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={this._onRenderFooterFiltresContent}
            >
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                        <div className="buttonFiltres">
                            <IconButton
                                iconProps={{ iconName: 'ClearFilter' }}
                                className="buttonFiltres"
                                title="Réinitialiser les filtres"
                                ariaLabel="Filtres"
                                onClick={this._reinitFiltres}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <ComboBoxProduit
                                onChange={(event, option) => this.setState({ filtreIdProduit: option.key })}
                                selectedKey={this.state.filtreIdProduit}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <ComboBoxStatutMandat
                                onChange={(event, option) => this.setState({ filtreIdStatutMandat: option.key })}
                                selectedKey={this.state.filtreIdStatutMandat}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <ComboBoxTypeMandat
                                disabled={this.state.filtreTypeMandat === 'WS'}
                                inclureAdministrateur
                                inclureCallCenter
                                inclureCommercialisateur
                                inclureControleDeGestionNational
                                inclureEbook
                                inclureMaisonIndividuelle
                                inclureModuleExterne
                                inclurePrimPromo
                                inclureWebServices
                                onChange={(event, option) => this.setState({ filtreIdTypeMandat: option.key })}
                                selectedKey={this.state.filtreIdTypeMandat}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <Toggle
                                label="Date de fin expirée"
                                onText="Oui"
                                offText="Non"
                                checked={this.state.filtreDateFinExpire}
                                onChange={(e, v) => this.setState({ filtreDateFinExpire: v })}
                            />
                        </div>
                    </div>
                </div>
            </Panel>

            {/*<FicheCompte
                onAffichePanelCompte={this.state.onAffichePanelCompte}
                onAnnuleFiche={this._masquerPanelCompte}
                onEnregistrementFiche={this._masquerPanelCompteEtRechargerLesDonnees}
            />*/}

            <FicheSociete
                idSociete={this._societeSelectionnee.idSociete}
                isOpen={this.state.onAffichePanelSociete}
                onAnnulation={this._masquerPanelSociete(false)}
                onEnregistrement={this._masquerPanelSociete(true)}
                onSuppression={this._masquerPanelSociete(true)}
            />

            <PanelComptes
                idSociete={this._societeSelectionnee.idSociete}
                isOpen={this.state.onAffichePanelComptes}
                nomSociete={this._societeSelectionnee.nomSociete}
                onDismiss={this._masquerPanelComptes}
            />

            <FicheCompte
                onAffichePanelCompte={this.state.onAffichePanelCompte}
                loginCompte={this._compteSelectionne}
                onAnnuleFiche={this._onDismissPanelCompte}
                onEnregistrementFiche={this._onCachePanelCompteEtRechargementDesDonnees}
                creationCompteEiffage={this.state.filtreTypeMandat === 'Eiffage'}
            />

            <FicheMandat
                idMandat={this.state.idMandat}
                idTypeMandat={this.state.idTypeMandat}
                isOpen={this.state.onAffichePanelMandat}
                onDismiss={this._masquerPanelMandat}
                onSave={this._masquerPanelMandatEtRechargerLesDonnees}
                typeDeMandat={this._letFiltreTypeMandat}
            />

            <Dialog
                hidden={!this.state.onAfficheDialogSuppressionMandat}
                onDismiss={this._masquerDialogSuppressionMandat}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Suppression du mandat',
                    subText: 'Attention, vous êtes en train de supprimer un mandat, souhaitez-vous continuer ?'
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton onClick={this._onSuppressionMandat} text="Supprimer" />
                    <DefaultButton onClick={this._masquerDialogSuppressionMandat} text="Annuler" />
                </DialogFooter>
            </Dialog>

            <Dialog
                hidden={!this.state.onAfficheDialogSuppressionMandatToutProduit}
                onDismiss={this._masquerDialogSuppressionMandat}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Suppression du mandat',
                    subText: 'Attention, vous êtes en train de supprimer tous les mandats (mandat tout produit), souhaitez-vous continuer ?'
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton onClick={this._onSuppressionMandat} text="Supprimer" />
                    <DefaultButton onClick={this._masquerDialogSuppressionMandat} text="Annuler" />
                </DialogFooter>
            </Dialog>

        </Fragment>;
    };

}

class PanelComptes extends React.Component {

    render = () => {
        return <Panel
            closeButtonAriaLabel="Fermer"
            headerText={"Comptes de la société " + this.props.nomSociete}
            isLightDismiss={true}
            isOpen={this.props.isOpen}
            onDismiss={this.props.onDismiss}
            styles={{ content: { height: "100%" } }}
            type={PanelType.extraLarge}
        >
            <DetailsListCompte
                activerActions={false}
                activerFiltres={false}
                idSociete={this.props.idSociete}
            />
        </Panel >
    };

}